/**
 * Overall zone for BR systems
 * - used in Olsztyn
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'
import Konva from 'konva'

import i18n from '../../../../i18n'

export default class Zone extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'zone',
        x: 0,
        y: 0,
        width: 115,
        height: 60,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Konva.Text({
        name: 'zoneText',
        x: 5,
        y: 10,
        width: 110,
        text: '',
        fontSize: 14,
        align: 'center',
        fill: 'black'
      })
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)
    // online
    if (this.online) {
      this.modifyShape('zone', 'fill', Color.sigBack)
    }

    // normal - green
    // EI - yellow
    // All block - red
    const zoneInfo = {
      0: { color: 'lightgreen', text: i18n.t(`visuals.zone-is-in-normal`) },
      1: { color: 'red', text: i18n.t(`visuals.zone-is-in-emergency-inhibit`) },
      2: { color: 'yellow', text: i18n.t(`visuals.zone-is-in-all-blocked`) }
    }
    if (status !== undefined && zoneInfo[status.state] !== undefined) {
      this.modifyShape('zone', 'fill', zoneInfo[status.state].color)
      this.modifyShape('zoneText', 'text', zoneInfo[status.state].text)
    }
  }
}
